import { createFileRoute } from '@tanstack/react-router'
import { ContactSectionOne } from '@/components/contact/ContactSectionOne'
import { ContactSectionTwo } from '@/components/contact/ContactSectionTwo'
import { Locations } from '@/components/Locations'

export const Route = createFileRoute('/contact/')({
	head: () => ({
		meta: [
			{ title: 'Contact Wellview Care | Get in Touch with Our Healthcare Team' },
			{
				name: 'description',
				content:
					'Contact Wellview Care for inquiries, appointments, or any questions about our healthcare services. Our dedicated team is here to assist' +
					' you. Reach out today and take the first step towards a healthier, happier life. ',
			},
		],
	}),
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<>
			<ContactSectionOne />
			<ContactSectionTwo />
			<Locations subtitle={''} title={'Visit Us'} />
		</>
	)
}
